/**
 * @file: useServiceRecordCount.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useCachedQuery } from '@euler/functions/useCachedQuery';
import { ServiceRecordSearchParams } from '@euler/services';
import { useServiceFactory } from '@euler/services/factory';

export function useServiceRecordCount(
  params: Omit<ServiceRecordSearchParams, 'licensePlateNo' | 'vin'> & {
    licensePlateNo: string;
    vin: string;
  },
  cache?: {
    key: string;
    ttl: number;
  },
) {
  const { serviceRecordService } = useServiceFactory();
  return useCachedQuery(cache?.key ?? '', cache?.ttl ?? 0, () =>
    serviceRecordService.getVehicleServiceRecordCount(params),
  );
}
